import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import { IoIosArrowDown } from "react-icons/io";
const { Option } = Select;

const SelectInput = ({
  lableName,
  option,
  onChange,
  value,
  name,
  fetchMoreOptions,
  className,
  lastElementRef,
}) => {
  const [options, setOptions] = useState(option);
  const [loading] = useState(false);

  useEffect(() => {
    setOptions(option);
    // setOptions((prev) => [...prev, ...option]);
  }, [option]);

  const handleChange = (selectedValue) => {
    onChange({
      target: {
        name,
        value: selectedValue,
      },
    });
  };

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    if (bottom) {
      fetchMoreOptions();
    }
  };

  return (
    <div className="flex flex-col gap-1">
      {lableName && <label htmlFor={lableName}>{lableName}</label>}
      <Select
        placement="bottomLeft"
        allowClear
        showSearch
        value={value || undefined}
        placeholder="Select"
        virtual={true}
        onPopupScroll={handleScroll}
        onChange={handleChange}
        suffixIcon={<IoIosArrowDown className="text-gray-500" size={24} />}
        dropdownRender={(menu) => (
          <div>
            {menu}
            {loading && (
              <div className="text-center p-2">
                <Spin />
              </div>
            )}
          </div>
        )}
        className={`h-12 w-full !rounded-xl border-[#e5e7eb] ${className}`}
        dropdownClassName="custom-dropdown" // Add custom class if needed
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {options?.map((e, index) => (
          <Option
            key={e.value}
            value={e?.value}
            ref={index === options?.length - 1 ? lastElementRef : null}
          >
            {e?.lable}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectInput;
